<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import VipBenefitSection2 from "./vip-benefit-section-2.svelte";
</script>

<VipBenefitSection2
	title={$t(Verbiage.freespins)}
	description={$t(Verbiage.vip_alt2_freespins_description)}
	image={cfgToThemeCdnPath('/about-vip/benefit-3.png')}
/>
